import { TenantSettingService } from "../../he-thong/tham-so-he-thong/TenantSettingService";
import { QR_PAYMENT_INVOICE_ENABLED_VALUE } from "./useQrPaymentInvoiceEnabled";
import { localized } from "../../../shared/language";

export const PETROL_QR_PAYMENT_NOT_REGISTERED_MESSAGE =
  localized("common.qrPaymentNotRegistered");

const isTenantSettingEnabled = (
  items: Array<{ value?: string }> | undefined,
): boolean =>
  Boolean(items?.length && items[0].value === QR_PAYMENT_INVOICE_ENABLED_VALUE);

export const fetchPetrolQrPaymentEnabled = async (): Promise<boolean> => {
  const paymentSetting = await TenantSettingService.getList({
    key: TenantSettingService.key.THANH_TOAN_QRCODE_HOA_DON,
  });

  return isTenantSettingEnabled(paymentSetting.items);
};
